import { SystemService } from "./SystemService";
import AuthService from "./AuthService";
import { v4 } from 'uuid';

class SalesService{

    systemService = null;
    api = null;
    authService = null;

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getSales(search = '', page = 1, perPage = 10){
        const getSalesPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`sales?search=${encodeURIComponent(search || '')}&page=${page || 1}&limit=${perPage || 10}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        })
        return getSalesPromise;
    }

    getSale(saleId){
        const getSalePromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`sales/sale/${saleId}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        })
        return getSalePromise;
    }

    getCustomers(search){
        const getCustomersPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`sales/customers?search=${search}&company=${config.company}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return getCustomersPromise;
    }

    getProjects(customerCode){
        const getProjectsPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`sales/projects/${customerCode}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return getProjectsPromise;
    }

    createSale(sale){
        sale.uuid = v4();
        let sessionid = this.authService.getSessionId();
        let salePromise = new Promise((resolve, reject) => {
            this.api.post('sales', sale, { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return salePromise;
    }

    getProducts(){
        let sessionid = this.authService.getSessionId();
        let productsPromise = new Promise((resolve, reject) => {
            this.api.get('sales/products', { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return productsPromise;
    }

    syncSaleToErp(sale){
        let sessionid = this.authService.getSessionId();
        let syncPromise = new Promise((resolve, reject) => {
            this.api.post('sales/send/erp', sale, { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return syncPromise;
    }

    getCostsPerCustomer(){
        let sessionid = this.authService.getSessionId();
        let costsPromise = new Promise((resolve, reject) => {
            this.api.get('sales/costsPerCustomer', { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return costsPromise;
    }

    updateCostsPerCustomer(costs){
        let sessionid = this.authService.getSessionId();
        let updateCostsPromise = new Promise((resolve, reject) => {
            this.api.post('sales/costs', costs, { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return updateCostsPromise;
    }

    getCostPerCustomer(customerCode){
        let sessionid = this.authService.getSessionId();
        let costsPromise = new Promise((resolve, reject) => {
            this.api.get(`sales/costsPerCustomer/${customerCode}`, { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
        });
        return costsPromise;
    }
}

export default SalesService;